import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import CompanyPage from './CompanyPage';
import MaskedInput from '../components/MaskedInput';
import AdminPage from './AdminPage';
import ErrorComponent from '../components/ErrorComponent';


const creationType = [
  "CNPJ"
];


export default class UploadPage extends PageComponent {
  static PageInfo = {

    path: "/Importation",
    parent: AdminPage,
    name: "menu.importation",
    access: { 1: true },
    permission: { "CONFIGURATION_SALES_HISTORY_UPLOAD": true },
    icon: "file-alt"
  }

  loaded = { brands: null, types: null, payment: null, billing: null, period: null, qatype: null };

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = false;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.costumerLoading = false;
    this.state.modalError = null;
    this.state.isModalVisible = null;
    this.state.form = {
      brand: null,
      hierarchy: null,
      fkClientType: null,
      label: null,
    };
    this.state.promotionalBudgetTypeId = null;
  }

  addNewFile() {
    this.setState({ modalLoading: true });

    var data = new FormData()
    data.append('file', this.state.file.files[0]);

    Connection.Secure(Connection.service +
      "SalesReport",
      {
        "method": "POST",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          this.setState({ modalLoading: false, isModalVisible: 'output', modalOutput: [Labels.GetLabel('generic.done')] });
        } else if (response.status == 400) {
          try {
            response.json().then(t => {
              this.setState({ modalLoading: false, isModalVisible: 'output', modalOutput: [Labels.GetLabel('generic.done')] });
            })
          } catch (e) {
            this.setState({ modalLoading: false, isModalVisible: 'output', modalOutput: [Labels.GetLabel('generic.done')] });
          }
        } else {
          this.setState({ modalLoading: false, isModalVisible: 'output', modalOutput: [Labels.GetLabel('generic.done')] });
        }
      })
      .catch((error) => {
        this.setState({ modalLoading: false, isModalVisible: 'output', modalOutput: [Labels.GetLabel('generic.done')] });
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  <div>
                    <div style={{ padding: 20 }}>
                      {/* <div className="generic_section_header">{Labels.GetLabel('program.programinfo')}</div> */}
                      <Form>
                        <Form.Label>{Labels.GetLabel("generic.file")}</Form.Label>
                        <Form.File id="exampleFormControlFile1" onChange={t => this.setState({ file: t.target })} />
                      </Form>
                      <br />
                      <br />
                      <div style={{ textAlign: "right", marginTop: 30 }}>
                        <Button variant="success" size="lg" disabled={this.state.file == null} onClick={() => this.setState({ isModalVisible: "confirm", modalLoading: false })}>{Labels.GetLabel("generic.confirm")}</Button>
                      </div>
                    </div>
                  </div>
                </div>
          }

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible != null}

          >
            <div>
              {
                this.state.modalInitializing == true ?
                  <div>
                    {Labels.GetLabel("adminstategroup.saving")}
                  </div>
                  :
                  this.state.isModalVisible == "output" ?
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("clients.results")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {this.state.modalOutput.map(t => <div style={{ padding: 10, borderBottom: "1px solid rgb(180,180,180)" }}>{t}</div>)}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("generic.confirm")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
                    :
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel(this.constructor.PageInfo.name)}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {Labels.GetLabel("clientsnew.confirmation")}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("adminstategroup.closebtn")}
                        </Button>
                        <Button variant="primary" onClick={() => this.addNewFile()}>
                          {Labels.GetLabel("adminstategroup.savebtn")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
              }
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
} 